<template>
    <div id="app" >
        
        <v-app id="inspire" >
            <v-card class="elevation-0 pa-2" >
                
                <v-navigation-drawer
                    :mini-variant.sync="mini"
                    clipped
                    fixed
                    v-model="drawer"
                    app
                >
                
                    <v-list>
                        <v-list-item-group>
                            <!-- <v-list-item class="px-2">
                            <v-list-item-content class="d-flex justify-center">
                                <v-img src="../img/logo_2.svg" 
                                max-width="120"
                                max-height="80">
                                </v-img>
                            </v-list-item-content>
                            </v-list-item> -->
                            
                            <v-list-item-content v-if="!mini" class="d-flex justify-center pb-0">
                               <v-list  two-line  align="center" justify="center" class="pl-2 pr-2 pb-0 pt-0 ma-0">АДМИНИСТРАТОР
                                   
                               </v-list>
                            </v-list-item-content>
                            <v-list-item-content class="d-flex justify-center">
                                <div class="d-flex justify-center">
                                    <v-btn v-if="!mini" small color="primary" @click="GoOut()">Выход</v-btn>
                                    <v-btn class="mx-2" fab dark small v-if="mini" color="primary" @click="GoOut()"><v-icon dark>mdi-exit-to-app</v-icon></v-btn>
                                </div>
                                
                            </v-list-item-content>
                        </v-list-item-group>
                        
                    </v-list>
                                
                    <v-divider></v-divider>
            
                    <v-list dense>
                    <v-list-item 
                        v-for="item in MenuItems"
                        :key="item.title"
                        @click="insideSettings=true"
                        :to="item.path"
                        
                    >
                        <v-list-item-icon >
                        <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
            
                        <v-list-item-content > 
                        <v-list-item-title >{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    
                    </v-list>
                    
                </v-navigation-drawer>
            <v-app-bar color="primary" dark app fixed clipped-left >
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title>Все Все Вместе (Проекты)</v-toolbar-title>
                <p style="margin: 0 1.5em 0em 0em;"></p>
                <v-progress-circular
                                  :size="40"
                                  color="white"
                                  indeterminate
                                  v-if="loadingF"
                                ></v-progress-circular>
            </v-app-bar>
            
            <v-main class="elevation-0" >
                <auto-logout></auto-logout>
                
                <v-alert dense  text   type="error"  dismissible v-model="alertOpti24" class="pa-1 ma-1">
                                Внимание! Ошибка подключения к сервису. Требуется выполнить корректную настройку подключения!
                </v-alert>
                <router-view/>
            </v-main>
            
            </v-card>
        </v-app>
    </div>
</template>

<script>
import AutoLogout from '../components/AutoLogout.vue'
import Vue from 'vue'    
    export default {
        components: { AutoLogout },
        name: "mainScreen",
        data() {
            return {
                insideSettings: false,
                drawer: true,
                mini: false,
                items: [
                    { title: 'Список проектов', icon: 'mdi mdi-human-greeting-proximity', path: "/mainScreen/vsevmesteProjList", if: true },
                ]
            }
        },
        methods: {
            loginUserCheck() {
                
                //console.log('CLICK')
                
            },
            GoOut() {
                this.$store.dispatch('logoutUser')
                Vue.ls.remove(this.$store.getters.UserMail)
                this.$router.push('/')
            }
        },
        computed: {
            MenuItems: function() {
                return this.items.filter(function (u) {
                    return u.if
                })
            },
            alertOpti24() {
                return false
            },
            loadingF(){
                return this.$store.getters.loading2
            },
        }
    }
</script>

